import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-Gestionadmin',
  templateUrl: './Gestionadmin.component.html',
  styleUrls: ['./Gestionadmin.component.css']
})
export class GestionadminComponent implements OnInit {

  constructor(public sanitizer: DomSanitizer) { }
  
  local:string;
  url:string;
  urlSafe: SafeResourceUrl;
  id_pais:string;
  ngOnInit(): void {
    this.id_pais=localStorage.getItem("id_pais");
    if(this.id_pais=='593'){
    this.url="http://62.171.172.148:8111/arbolArchivo/?ruta=/ecuador/gestion/";
    this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    }else{
      this.url="http://62.171.172.148:8111/arbolArchivo/?ruta=/panama/gestion/";
      this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
     
    }
  }


 

}
